import React, { FC } from "react";
import { Id, OrgUnit } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilState, useRecoilValue } from "recoil";
import { activeSubscriptionIdState, orgUnitsState } from "../../../atoms";
import { useForm } from "react-hook-form";
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Stack,
  useToast,
} from "@chakra-ui/react";
import { renameOrgUnit } from "../../../api/rename-org-unit";

type FormData = Pick<OrgUnit, "name">;

type Props = {
  id: Id;
  onSuccess: () => void;
};

export const RenameOrgUnit: FC<Props> = (props) => {
  const { id, onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const [orgUnits, setOrgUnits] = useRecoilState(orgUnitsState);
  const orgUnit = orgUnits[id];

  const { register, handleSubmit, errors, watch } = useForm<FormData>({
    defaultValues: { name: orgUnit.name },
  });
  const watchName = watch("name");

  const onSubmit = () => {
    send(state.matches("failure") ? "RETRY" : "FETCH");
  };

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        renameOrgUnit({
          id,
          name: watchName,
          parentOrgUnitId: orgUnit?.parentOrgUnitId,
          subscriptionId: activeSubscriptionId as Id,
        }),
    },

    actions: {
      success: (_, event: any) => {
        setOrgUnits(event.data.orgUnits);
        onSuccess();
        toast({
          title: "naam van organisatie-eenheid aangepast",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "naam van organisatie-eenheid aanpassen niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={8} align="start">
        <FormControl isRequired isInvalid={errors.name !== undefined}>
          <FormLabel>naam</FormLabel>
          <Input
            name="name"
            ref={register({
              required: "je hebt geen naam ingevuld",
            })}
          />
          <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
        </FormControl>

        <Button type="submit" size="sm" isLoading={state.matches("loading")}>
          pas aan
        </Button>
      </Stack>
    </form>
  );
};
